import { render, staticRenderFns } from "./UpdateScore.vue?vue&type=template&id=2319118b"
import script from "./UpdateScore.vue?vue&type=script&lang=js"
export * from "./UpdateScore.vue?vue&type=script&lang=js"
import style0 from "./UpdateScore.vue?vue&type=style&index=0&id=2319118b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports